import { render, staticRenderFns } from "./SubPage.vue?vue&type=template&id=0b39d080&scoped=true"
import script from "./SubPage.vue?vue&type=script&lang=js"
export * from "./SubPage.vue?vue&type=script&lang=js"
import style0 from "./SubPage.vue?vue&type=style&index=0&id=0b39d080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b39d080",
  null
  
)

export default component.exports